module.exports = __webpack_public_path__ + "static/media/c1.14c8c6e5.png";